'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _crumb = require('./crumb');

var _crumb2 = _interopRequireDefault(_crumb);

var BreadCrumb = (function (_Component) {
    _inherits(BreadCrumb, _Component);

    function BreadCrumb() {
        _classCallCheck(this, BreadCrumb);

        _get(Object.getPrototypeOf(BreadCrumb.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(BreadCrumb, [{
        key: '_renderContent',
        value: function _renderContent() {
            return _react2['default'].Children.map(this.props.children, function (child) {
                return child;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var prefixName = this.props.prefixName;

            return _react2['default'].createElement(
                'ol',
                { className: prefixName + '-breadcrumb' },
                this._renderContent()
            );
        }
    }], [{
        key: 'propTypes',
        value: {
            prefixName: _react2['default'].PropTypes.string
        },
        enumerable: true
    }, {
        key: 'defaultProps',
        value: {
            prefixName: 'salt'
        },
        enumerable: true
    }]);

    return BreadCrumb;
})(_react.Component);

BreadCrumb.Crumb = _crumb2['default'];

exports['default'] = BreadCrumb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_rs-breadcrumb@0.1.1@rs-breadcrumb/dist/breadcrumb.js
// module id = 1909
// module chunks = 0